import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import { Button, Form, Label, Input, Row, Col } from "reactstrap";
import axios from "axios";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import Header from "../../layout/Header/Header";
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';

function CargosCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_CARGOS = process.env.REACT_APP_URL_CARGOS;
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_CONCEPTOS = process.env.REACT_APP_URL_CONCEPTOS;
  const [text, setText] = useState(false);

  const [cliente, setCliente] = useState([]);
  const [conceptos, setConceptos] = useState([]);
  const [fecha, setFecha] = useState("");
  const [selectedConcepto, setSelectedConcepto] = useState("");
  const [descripcion, setDescripcion] = useState("");
  const [importe, setImporte] = useState("");
  const [selectedCliente, setSelectedCliente] = useState("");
  const [value, setValue] = useState('');
  const [validaBoton, setValidaBoton] = useState(true);

  const clear = () => {
    setCliente([]);
    setFecha("");
    setSelectedConcepto("");
    setDescripcion("");
    setImporte("");
    setValue("");
    setValidaBoton(true)
  };

  useEffect(() => {
    axios
      .get(URL_CLIENTES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allClientes = res.data;
        setCliente(allClientes);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_CONCEPTOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allConceptos = res.data;
        setConceptos(allConceptos);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const saveCargo = async (event) => {
    event.preventDefault();
    setValidaBoton(false)
    try {
      await axios
      .post(
        URL_CARGOS,
        {
          mensualidad: "No",
          fecha,
          conceptos: selectedConcepto,
          descripcion,
          importe,
          clientes: value._id,
          abonos: 0,
          saldo: importe
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )

      .then(() => {
        axios
        .post(
          URL_LOGS,
          {
            tipo:'Cargo',
            detalle: `${value._id}`,
            user: user.id
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        clear();
        Swal.fire("Good job!", "Creado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
       .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
        console.log(error);
        setValidaBoton(true)
      })
    }catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
      });
      console.log(error);
    }
  };

  const options = cliente.map((option) => {
    const junta = option.nombre_comercial
    const firstLetter = option.nombre_comercial[0].toUpperCase();
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? '0-9' : firstLetter,
      ...option, junta
    };
  })

  return (
    <>
      <Header />
      <br />
      {user.usuarios_permisos ? (
        <div className="container">
          <div className="card container col-sm-8">
            <h3 align="center">Crea un Cargo</h3>
            <Form onSubmit={saveCargo}>
              <Row>
                <Col>
                  <Label className="mr-sm-2">Cliente</Label>
                  <Autocomplete
                    size="small"
                    value={value}
                    onChange={(event, selectedCliente) => {
                      setValue(selectedCliente);
                    }}
                    options={options.sort((a, b) => -b.firstLetter.localeCompare(a.firstLetter))}
                    groupBy={(option) => option.firstLetter}
                    getOptionLabel={(option) => option.junta}
                    renderInput={(params) => <TextField {...params} label="Selecciona" variant="outlined" />}
                    renderOption={(option) => (
                      <React.Fragment>
                    {option.nombre_comercial}
                      </React.Fragment>
                    )}
                  />
                </Col>
                <Col md={6}>
                  <Label>Fecha</Label>
                  <Input
                    type="date"
                    value={fecha}
                    required
                    onChange={(e) => {
                      setFecha(e.target.value);
                    }}
                  />
                </Col>
                
              </Row>
              <Row>
                <Col md={6}>
                  <Label className="mr-sm-2">Concepto</Label>
                  <Input
                    className="col-sm-12"
                    type="select"
                    value={selectedConcepto}
                    required
                    onChange={(e) => {
                      setSelectedConcepto(e.target.value);
                    }}
                  >
                    <option value="">Selecciona</option>
                    {conceptos
                      .sort((a, b) => (a.name > b.name ? 1 : -1))
                      .map((a) => {
                        return <option value={a._id}>{a.name}</option>;
                      })}
                  </Input>
                </Col>
                <Col md={6}>
                  <Label>Importe</Label>
                  <Input
                    className="col-sm-12"
                    type="number"
                    placeholder="Importe"
                    value={importe}
                    required
                    onChange={(e) => {
                      setImporte(e.target.value);
                    }}
                  />
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <Label className="mr-sm-2">Descripcion</Label>
                  <Input
                    className="col-sm-12"
                    type="text"
                    placeholder="Descripcion"
                    value={descripcion}
                    required
                    onChange={(e) => {
                      setDescripcion(e.target.value);
                    }}
                  />
                </Col>
              </Row>
              <Row>
              {validaBoton ? (
        <Button type="submit" className="btn btn-success">
        Registrar
      </Button>
      ):(
      <Button type="submit" className="btn btn-success" disabled>
        Registrar
      </Button>)}
                {/* <div>
                  <SweetAlert
                    show={text}
                    title="Creado con Exito"
                    onConfirm={() => {
                      setText(false);
                    }}
                  />
                </div> */}
                <Button
                  href="/ListadoCargos"
                  className="btn btn-danger"
                  id="botonListado"
                >
                  Regresar
                </Button>
              </Row>
            </Form>
          </div>
        </div>
      ) : undefined}
    </>
  );
}

export default CargosCreate;
